import React from 'react';
import { Download, Calendar, CheckCircle } from 'lucide-react';

export default function ChangelogPage() {
  const versions = [
    {
      version: "v2.1.0",
      title: "Version",
      date: "2025-12-10",
      time: null,
      description: "Migrated to a modern AWS architecture with secure SFTP, and Amazon RDS database support.",
      details: []
    },
        {
      version: "v1.0.2",
      title: "Version",
      date: "2025-07-04",
      time: null,
      description: "System enhancement with 8 diseases prediction, including image quality check.",
      details: []
    },
        {
      version: "v1.0.1",
      title: "Version",
      date: "2024-10-16",
      time: null,
      description: "Fundus eye scanning with 4 standard diseases prediction.",
      details: []
    },
    {
      version: "v0.1.0",
      title: "Initial version",
      date: "2024-06-12",
      time: "02:21:46pm",
      description: "Beta for application framework and reporting. Login access.",
      details: [
        "Framework is based on Smarty v5.0.6 and Bootstrap 5.3.0.",
        "For this application to work properly, it is recommended to use the following software and library versions:",
        "PHP v8.3.x, supporting SQLite3 Library v3.40.0 and above",
        "tcpdf v6.7.5 (2024-04-20)"
      ]
    },


  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      <div >
        {/* Header */}
        <div className=" rounded-lg shadow-sm p-8 mb-8">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold text-slate-800 mb-2">
                Eye-AI System Changelog
              </h1>
              <p className="text-slate-600">
                Track the evolution of our medical imaging platform
              </p>
            </div>
            
          </div>
        </div>

        {/* Timeline */}
        <div className="relative">
          {versions.map((item, index) => (
            <div key={index} className="relative mb-8 last:mb-0">
              {/* Timeline line */}
              {index !== versions.length - 1 && (
                <div className="absolute left-6 top-16 bottom-0 w-0.5 bg-blue-200" />
              )}

              {/* Version Card */}
              <div className="bg-white rounded-lg shadow-sm p-6 ml-16 relative">
                {/* Timeline dot */}
                <div className="absolute -left-10 top-8 w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center shadow-lg">
                  <CheckCircle className="text-white" size={24} />
                </div>

                {/* Version Header */}
                <div className="mb-4">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-sm font-semibold">
                      {item.version}
                    </span>
                    <h2 className="text-xl font-bold text-slate-800">
                      {item.title} {item.version}
                    </h2>
                  </div>
                  <div className="flex items-center gap-2 text-slate-500 text-sm">
                    <Calendar size={16} />
                    <span>
                      {item.date}
                      {item.time && ` / ${item.time}`}
                    </span>
                  </div>
                </div>

                {/* Description */}
                <p className="text-slate-700 mb-4 leading-relaxed">
                  {item.description}
                </p>

                {/* Details */}
                {item.details.length > 0 && (
                  <div className="bg-slate-50 rounded-lg p-4 space-y-2">
                    {item.details.map((detail, idx) => (
                      <p key={idx} className="text-sm text-slate-600 leading-relaxed">
                        {detail.startsWith('-') ? (
                          <span className="flex gap-2">
                            <span className="text-blue-600 font-bold">•</span>
                            <span>{detail.substring(1).trim()}</span>
                          </span>
                        ) : (
                          detail
                        )}
                      </p>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        {/* <div className="mt-12 text-center text-slate-500 text-sm">
          <p>© 2024-2025 Eye-AI System. All rights reserved.</p>
        </div> */}
      </div>
    </div>
  );
}